import * as React from 'react';
import { GatsbyLinkProps, Link } from 'gatsby';

function MenuLink<TState>({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...rest
}: Omit<GatsbyLinkProps<TState>, 'ref'>) {
  const internal = /^\/(?!\/)/.test(to);

  // Use Gatsby Link for internal links, and <a> for rests
  if (internal) {
    return (
      <Link<TState>
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      >
        {children}
      </Link>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <a href={to} {...rest} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

export default MenuLink;
